import { render } from "./InlineTextLoader.vue?vue&type=template&id=32808a5b&scoped=true&ts=true"
import script from "./InlineTextLoader.vue?vue&type=script&lang=ts"
export * from "./InlineTextLoader.vue?vue&type=script&lang=ts"

import "./InlineTextLoader.vue?vue&type=style&index=0&id=32808a5b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32808a5b"]])

export default __exports__